import { configureStore } from '@reduxjs/toolkit'
import {loadingSlice} from "./Store/loadingSlice";
import {burguerMenuSlice} from "Store/burguerMenuSlice";
import {cartSlice} from "Store/cartSlice";
import {userSlice} from "Store/userSlice";

export const store = configureStore({
    reducer: {
        loading: loadingSlice.reducer,
        isBurguerMenuOpen: burguerMenuSlice.reducer,
        cart: cartSlice.reducer,
        user: userSlice.reducer
    }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
